module.exports = __webpack_public_path__ + "admin/img/member_avatar_female.c1b19a9f.png";